import { useContext } from 'react';
import { element } from '../../../core/elements';
import { Arc } from '../../../primitives/shape/Arc';
import { tooltipEvent } from '../../common/events/chart-events';
import TooltipContext from '../../common/events/context/TooltipContext';
import { useChartEvents } from '../../common/events/hooks/useChartEvents';
import { jsx as _jsx } from "react/jsx-runtime";
export const DonutTooltipOverlay = element(function DonutTooltipOverlay(_ref) {
  let {
    arcs,
    onClick
  } = _ref;
  const {
    showTooltip,
    hideTooltip
  } = useContext(TooltipContext);
  const {
    emit: emitMouseMove
  } = useChartEvents(tooltipEvent, 'pointermove', showTooltip);
  const {
    emit: emitClick
  } = useChartEvents(tooltipEvent, 'pointerdown', onClick);
  const {
    emit: emitOut
  } = useChartEvents(tooltipEvent, 'pointerout', hideTooltip);
  return /*#__PURE__*/_jsx("g", {
    style: {
      cursor: onClick ? 'pointer' : 'default'
    },
    children: arcs.map(arc => /*#__PURE__*/_jsx(Arc, {
      onPointerMove: e => emitMouseMove(e, {
        datum: arc.data,
        distance: 0
      }),
      onPointerOut: e => emitOut(e, undefined),
      onPointerDown: e => emitClick(e, {
        datum: arc.data,
        distance: 0
      }),
      ariaLabel: `${arc.ariaLabel}-overlay`,
      "aria-hidden": true,
      outerRadius: arc.outerRadius,
      innerRadius: arc.innerRadius,
      startAngle: arc.startAngle,
      endAngle: arc.endAngle,
      padAngle: arc.padAngle,
      fill: 'transparent'
    }, `DonutStack-${arc.key}`))
  });
});